import { ITableObject, QRARowEntryCRID } from '$/types'

export const getGraphUnits = (
  tableData: ITableObject<QRARowEntryCRID> | undefined
) => {
  const unitData: Record<string, string>[] = []

  tableData?.columnDefinitions.forEach((col) => {
    const leftParentheses = col.headerName?.indexOf('(') ?? -1
    const rightParentheses = col.headerName?.indexOf(')') ?? -1

    if (leftParentheses == -1 || rightParentheses == -1) {
      unitData.push({ field: col.field, unit: '' })
    } else {
      const unitName = col.headerName?.substring(
        leftParentheses + 1,
        rightParentheses
      )

      unitData.push({ field: col.field, unit: unitName ?? '' })
    }
  })

  return unitData
}
